import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Button from "../components/button/Button";
import useTranslation from "../hooks/i18n/useTranslation";
import "./ServerError.css";

const ServerError = ({
  fallbackRoute = "/",
  errorCode = null,
  errorMessage = null
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [countdown, setCountdown] = useState(5);
  const [isTimerActive, setIsTimerActive] = useState(true);

  // Get error code and message from URL params if not provided as props
  const urlErrorCode = searchParams.get("code");
  const urlErrorMessage = searchParams.get("message");
  const displayErrorCode = errorCode || urlErrorCode || "500";
  const displayErrorMessage = errorMessage || urlErrorMessage;

  useEffect(() => {
    if (!isTimerActive) return;

    if (countdown <= 0) {
      navigate(fallbackRoute);
      return;
    }

    const timer = setInterval(() => {
      setCountdown(prev => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [countdown, isTimerActive, navigate, fallbackRoute]);

  const handleNavigation = path => {
    navigate(path);
  };

  const handleCancelRedirect = () => {
    setIsTimerActive(false);
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="server-error-container">
      <div className="server-error-content">
        <h1 className="server-error-code">{displayErrorCode}</h1>
        <h2 className="server-error-title">{t("290")}</h2>
        <p className="server-error-subtitle">{t("291")}</p>
        <p className="server-error-message">
          {displayErrorMessage || t("292")}
        </p>
        {isTimerActive && countdown > 0 && (
          <p className="server-error-countdown">
            {countdown === 1
              ? t("294").replace("{count}", countdown)
              : t("293").replace("{count}", countdown)
            }
          </p>
        )}
        <div className="server-error-button-wrapper">
          <Button
            value={t("297")}
            onClick={() => handleNavigation(fallbackRoute)}
          />
          {isTimerActive && (
            <Button
              value={t("295")}
              onClick={handleCancelRedirect}
            />
          )}
          <Button
            value={t("298")}
            onClick={handleGoBack}
          />
        </div>
      </div>
    </div>
  );
};

export default ServerError;
